import { render, staticRenderFns } from "./ProductionOrderDetailList.vue?vue&type=template&id=b5267660&"
import script from "./ProductionOrderDetailList.vue?vue&type=script&lang=js&"
export * from "./ProductionOrderDetailList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports